import {
  Component,
  Input,
  OnDestroy, inject, DestroyRef
} from "@angular/core";
import { DetailsConfig, SharedUiDetailsModule } from '@snelstart/ui-details';
import { ButtonConfiguration, SharedUiButtonModule } from '@snelstart/ui-button';
import {filter, Observable, shareReplay, tap} from "rxjs";
import {
  BokkzBtwDataService, BokkzBtwLogic, ValueAddedTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {ToastService} from "@snelstart/ui-toast";
import { AangifteVatComponent } from '../vat/aangifte-vat/aangifte-vat.component';
import { AangifteIcpComponent } from '../vat/aangifte-icp/aangifte-icp.component';
import { OverzichtComponent } from '../vat/overzicht/overzicht.component';
import { AlgemeenComponent } from '../vat/algemeen/algemeen.component';
import { SuppletiesComponent } from '../vat/suppleties/suppleties.component';
import { AdministratieKoppelenComponent } from '../vat/administratie-koppelen/administratie-koppelen.component';
import { FiscaleEenheidVatComponent } from '../vat/fiscale-eenheid-vat/fiscale-eenheid-vat.component';
import { CommonModule } from '@angular/common';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tax-vat-details',
  templateUrl: './feature-tax-vat-details.component.html',
  styleUrls: ['./feature-tax-vat-details.component.scss'],
  imports: [
    AangifteVatComponent,
    AangifteIcpComponent,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    OverzichtComponent,
    AlgemeenComponent,
    SuppletiesComponent,
    AdministratieKoppelenComponent,
    FiscaleEenheidVatComponent,
    CommonModule
  ]
})
export class FeatureTaxVatDetailsComponent implements OnDestroy {

  @Input() public id!: string;
  private readonly destroyRef = inject(DestroyRef);
  private readonly dataService = inject(BokkzBtwDataService);
  private readonly btwService = inject(BokkzBtwLogic);
  public readonly toastService = inject(ToastService);
  public valueAddedTaxEntity= {} as ValueAddedTaxEntity;
  public dialogInfoVisible = false;

  public detailsConfig = DetailsConfig.create({
    hideArrowButtons: true,
  });

  readonly corporateTaxEntity$: Observable<ValueAddedTaxEntity> =
    this.dataService.valueAddedTaxEntity$.pipe(
      filter((data): data is ValueAddedTaxEntity => !!data?.sstRelationId),
      tap(data => {
        this.valueAddedTaxEntity = data;
      }),
      takeUntilDestroyed(this.destroyRef),
      shareReplay({bufferSize: 1, refCount: true})
    );

  readonly saveButtonConfig = ButtonConfiguration.create({
    onClick: () => this.saveForm(),
  });

  ngOnDestroy(): void {
    // No-op: lifecycle cleanup is handled via takeUntilDestroyed.
  }

  saveForm(): Observable<void> {
    return this.btwService.postValueAddedTaxEntity(this.valueAddedTaxEntity, false);
  }
}
